import { api } from '../../services/api';
import {
  GET_INFO_GENERAL_FAILURE,
  GET_INFO_GENERAL_SUCCESS,
  SET_LOADING_INFO,
} from '../reducers/types';

export const getInfo = () => async (dispatch) => {
  try {
    dispatch({ type: SET_LOADING_INFO });
    const response = await api.get('/informacion_general');
    dispatch({
      type: GET_INFO_GENERAL_SUCCESS,
      payload: response.data.informacion_general,
    });
  } catch (error) {
    console.error('Error en getInfo:', error);
    dispatch({ type: GET_INFO_GENERAL_FAILURE, payload: error });
  }
};
